import type { IconNode } from '../types';

/**
 * @name stairs
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTAiIGhlaWdodD0iNCIgeD0iMiIgeT0iMTYiIC8+CiAgPHJlY3Qgd2lkdGg9IjEwIiBoZWlnaHQ9IjQiIHg9IjQiIHk9IjEyIiAvPgogIDxyZWN0IHdpZHRoPSIxMCIgaGVpZ2h0PSI0IiB4PSI2IiB5PSI4IiAvPgogIDxyZWN0IHdpZHRoPSIxMCIgaGVpZ2h0PSI0IiB4PSI4IiB5PSI0IiAvPgogIDxwYXRoIGQ9Ik0xMiAyMGgxMFY0aC00IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/stairs
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const stairs: IconNode = [
  ['rect', { width: '10', height: '4', x: '2', y: '16', key: '1ckky7' }],
  ['rect', { width: '10', height: '4', x: '4', y: '12', key: 'gwr19b' }],
  ['rect', { width: '10', height: '4', x: '6', y: '8', key: '1m5n4n' }],
  ['rect', { width: '10', height: '4', x: '8', y: '4', key: '1ruzcg' }],
  ['path', { d: 'M12 20h10V4h-4', key: '1i2fc9' }],
];

export default stairs;
